export default __webpack_public_path__ + "static/media/Luggage1.82c8d166.png";